import store from '@/store'
import clone from 'clone'
// Menu Utilities

// Recursive function to search by name
// Replaced by flatten menu implementation
/*
function findNode(name, currentNode) {
  let currentChild, result

  if (name === currentNode.name) {
    return currentNode
  } else {
    // Use a for loop instead of forEach to avoid nested functions
    // Otherwise "return" will not work properly
    if (currentNode.children && currentNode.children.length > 0) {
      for (let i = 0; i < currentNode.children.length; i++) {
        currentChild = currentNode.children[i]

        // Search in the current child
        result = findNode(name, currentChild)

        // Return the result if the node has been found
        if (result !== false) {
          return result
        }
      }
    }
    // The node has not been found and we have no more options
    return false
  }
}
*/

// Ref from : https://gist.github.com/penguinboy/762197
/*
const flattenObject = function (ob) {
  var toReturn = {}

  for (var i in ob) {
    if (!ob.hasOwnProperty(i)) continue

    if ((typeof ob[i]) === 'object') {
      var flatObject = flattenObject(ob[i])
      for (var x in flatObject) {
        if (!flatObject.hasOwnProperty(x)) continue

        toReturn[i + '.' + x] = flatObject[x]
      }
    } else {
      toReturn[i] = ob[i]
    }
  }
  return toReturn
}
*/

export const flattenMenu = (mainm) => {
  const ob = clone(mainm)
  let toReturn = {}
  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue
    if (ob[i].children) {
      toReturn[i] = ob[i]
      var flatObject2 = flattenMenu(ob[i].children)
      for (var y in flatObject2) {
        if (!flatObject2.hasOwnProperty(y)) continue

        toReturn[i + '.' + y] = flatObject2[y]
      }
    } else {
      toReturn[i] = ob[i]
    }
  }
  return toReturn
}

export const flattenSearchableMenu = (mainm) => {
  const ob = clone(mainm)
  let toReturn = {}
  for (let i in ob) {
    if (!ob.hasOwnProperty(i)) continue
    if (ob[i].children && (!ob[i].hidden || (ob[i].hidden && ob[i].searchable))) {
      toReturn[i] = ob[i]
      var flatObject2 = flattenSearchableMenu(ob[i].children)
      for (var y in flatObject2) {
        if (!flatObject2.hasOwnProperty(y)) continue

        toReturn[i + '.' + y] = flatObject2[y]
      }
    } else if (!ob[i].hidden || (ob[i].hidden && ob[i].searchable)) {
      toReturn[i] = ob[i]
    }
  }
  return toReturn
}

// To add access to Menu from Route
export const addAccess = (items) => {
  if (items && items.length > 0) {
    for (var i = items.length - 1; i >= 0; i--) {
      const item = items[i]
      if (!item.access) {
        // Find from router
        const routeItem = store.getters.getRouteMenu(item.name)
        if (routeItem && routeItem.meta && routeItem.meta.access) {
          Object.assign(item, {
            access: routeItem.meta.access
          })
        }
        if (item.access) {
          // Check if it is permitted
          const permit = store.getters.checkAccess(item.access.privileges)
          if (!permit) {
            // Remove not permitted item
            items.splice(i, 1)
          }
        }
      }
      if (item.children) {
        addAccess(item.children)
      }
    }
  }
}

// To remove empty children from menu
export const removeEmptyChild = (items) => {
  if (items && items.length > 0) {
    let toRemove = true
    for (var i = items.length - 1; i >= 0; i--) {
      const item = items[i]
      if (item.route !== true && (!item.children || item.children.length === 0)) {
        items.splice(i, 1)
      } else if (item.children && item.children.length > 0 && item.route !== true && removeEmptyChild(item.children)) {
        items.splice(i, 1)
      } else {
        toRemove = false
      }
    }
    return toRemove
  } else {
    return true
  }
}
